import React from "react";



import './Benefits.css';
import BenefitsList from './components/BenefitsList/BenefitsList';

const Benefits = props => {


    return (
        <section style={{marginTop: '2em', marginBottom:'3em'}}>
        <BenefitsList></BenefitsList>
        </section>
    );
};

export default Benefits;